import { render, staticRenderFns } from "./WorkOrderViewFormulationSection.vue?vue&type=template&id=77ebe706&scoped=true&"
import script from "./WorkOrderViewFormulationSection.vue?vue&type=script&lang=js&"
export * from "./WorkOrderViewFormulationSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77ebe706",
  null
  
)

export default component.exports